<template>
  <div class="v3-cashero-footer">
    <div class="container">
      <div class="row mb-3">
        <div class="col-lg-2 col-md-4 col-12 text-center text-md-left">
          <img
            class="v3-cashero-footer-logo"
            src="/img/logo.png"
            alt="Logo"
          >
        </div>
        <div class="col-lg-7 col-md-4 col-12 text-center text-md-left">
          <div class="row footer-content">
            <div class="col-lg-3 pl-0 mt-3 mt-lg-2">
              <p><strong>{{ $t('string.products') }}</strong></p>
              <ul class="v3-cashhero-footer-link">
                <template v-if="ourProducts && Array.isArray(ourProducts) && ourProducts.length > 0">
                  <li
                    v-for="(item, key) in ourProducts"
                    :key="key"
                  >
                    <router-link
                      :title="$t(item.label)"
                      to="/"
                      @click.native="toRoute(item.route)"
                    >
                      {{ $t(item.label) }}
                    </router-link>
                  </li>
                </template>
              </ul>
            </div>
            <div class="col-lg-3 pl-0 mt-3 mt-lg-2">
              <p><strong>{{ $t('string.about') }}</strong></p>
              <ul class="v3-cashhero-footer-link">
                <li
                  v-for="(item, key) in aboutUs"
                  :key="key"
                >
                  <router-link :to="item.link">
                    {{ $t(item.label) }}
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="col-lg-3 pl-0 mt-3 mt-lg-2">
              <p><strong>{{ $t('string.partner') }}</strong></p>
              <ul class="v3-cashhero-footer-link">
                <li
                  v-for="(item, key) in ourPartner"
                  :key="key"
                >
                  <router-link
                    :title=" $t(item.label)"
                    :to="{name: item.link}"
                  >
                    {{ $t(item.label) }}
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="col-lg-3 pl-0 mt-3 mt-lg-2">
              <p><strong>{{ $t('string.forInvestor') }}</strong></p>
              <ul class="v3-cashhero-footer-link">
                <li>
                  <router-link :to="{name: 'invest-form'}">
                    {{ $t('label.investWithUs') }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-12 mt-3 mt-lg-2 text-center text-md-left">
          <p style="font-weight: bold">
            {{ $t('string.contactUs') }}
          </p>
          <p class="font-lighter">
            <a
              :href="`mailto:${email}`"
              class="text-white"
              target="_blank"
            >
              {{ email }}
            </a>
          </p>
          <p class="font-lighter">
            <a
              :href="`tel:${phone_number_call}`"
              class="text-white"
            >
              {{ phone_number }}
            </a>
          </p>
          <p class="font-lighter">
            {{ address['label_' + $i18n.locale] }}
          </p>
          <div class="v3-cashhero-footer-social-media">
            <span
              v-for="(social, key) in socials"
              :key="key"
            >
              <a
                :href="social.link"
                :title="social.link"
                target="_blank"
              >
                <i :class="social.icon" />
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: var(--dark-blue)">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 text-center">
            <p style="font-size: 12px; padding: 20px 0 0">
              {{ $t('string.cashheroColLTD') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'V3CashHeroFooter',
  data () {
    return {
      email: process.env.VUE_APP_EMAIL,
      phone_number: process.env.VUE_APP_HOT_LINE,
      phone_number_call: process.env.VUE_APP_HOT_LINE_CALL,
      address: {
        label_km: process.env.VUE_APP_ADDRESS_KM,
        label_en: process.env.VUE_APP_ADDRESS_EN
      },
      socials: [
        { icon: 'fab fa-facebook-square', link: process.env.VUE_APP_FACEBOOK_LINK },
        { icon: 'fab fa-instagram', link: process.env.VUE_APP_INSTAGRAM_LINK },
        { icon: 'fab fa-linkedin', link: process.env.VUE_APP_LINKEDIN_LINK }
      ],
      ourPartner: [
        { label: 'string.beOurPartner', link: 'our-partner' }
      ],
      aboutUs: [
        { label: 'string.aboutUs', link: 'about' }
      ],
      ourProducts: [
        { label: 'label.payDayLoan', link: '#', route: 'payday_loan' },
        { label: 'label.personalLoan', link: '#', route: 'personal_loan' },
        { label: 'label.purchasing', link: '#', route: 'purchasing' },
        { label: 'label.pawn', link: '#', route: 'pawn' }
      ]
    }
  },
  computed: Object.assign(mapState({
    data: state => state.borrow
  }), {
    company () {
      return [
        { label: this.$t('string.whoWeAre'), link: '#' },
        { label: this.$t('string.blog'), link: '#' },
        { label: this.$t('string.press'), link: '#' },
        { label: this.$t('string.careers'), link: '#' }
      ]
    }
  }),
  methods: {
    toRoute (route_name) {
      if (route_name === 'payday_loan') {
        this.data.loanType = 'Payday'
        this.$router.push({ name: 'borrow-form', params: { formType: 'borrow' } })
      } else if (route_name === 'personal_loan') {
        this.data.loanType = 'Personal'
        this.$router.push({ name: 'borrow-form', params: { formType: 'borrow' } })
      } else if (route_name === 'purchasing') {
        this.data.loanType = 'Purchasing'
        this.$router.push({ name: 'purchasing-form', params: { formType: 'borrow' } })
      } else if (route_name === 'pawn') {
        this.data.loanType = 'Pawn'
        this.$router.push({ name: 'pawn-form', params: { formType: 'borrow' } })
      }
    }
  }
}
</script>

<style scoped>
.v3-cashero-footer {
  background: var(--primary);
  color: var(--white);
  padding-top: 30px;
}

.v3-cashero-footer-logo {
  width: 140px;
  margin-bottom: 15px;
}

.v3-cashhero-footer-social-media span i {
  margin-right: 10px;
  color: var(--white);
  font-size: 30px;
}

.v3-cashero-footer ul {
  padding: 0;
}

.v3-cashero-footer ul li {
  list-style: none;
  padding-bottom: 10px;

}

.v3-cashero-footer ul li a {
  text-decoration: none;
  color: var(--white);
}

.v3-cashero-footer ul li a,
.font-lighter {
  font-weight: lighter;
}

.v3-cashero-footer .maps {
  background-size: cover;
  background-position: center center;
  height: 150px;
}

@media (max-width: 767px) {
  .v3-cashero-footer-logo {
    width: 200px;
    margin-bottom: 45px;
  }

  .v3-cashhero-footer-social-media span i {
    margin-left: 0;
    margin-right: 10px;
  }
}
</style>
